<template>
    <v-container fluid>
        <!-- Search bar -->
        <v-row align="center">
            <v-col cols="12" class="text-right mb-2">
                <!-- Button to open add notice dialog -->
                <v-btn small color="primary" dark @click="openDialog">
                    <v-icon small class="mr-2">mdi-plus</v-icon>FAIRE UNE SOLLICITATION
                </v-btn>
            </v-col>
        </v-row>

        <!-- Dialog for adding new notice -->
        <v-dialog v-model="dialog" max-width="800px" persistent>
            <v-card>
                <v-card-title>
                    <h4 class="headline">{{ formTitle }}</h4>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field v-model="nom" label="Nom"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="prenom" label="Prénom"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="email" label="Email"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="societe" label="Société"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="pieceJointeDemande" placeholder="Charger le fichier"
                                label="Pièce jointe de la Demande adressée à l'autorité de regulation" multiple
                                prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="copieContrat" placeholder="Charger le fichier"
                                label="Copie du contrat / bon de commande" multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="preuveExecution" placeholder="Charger le fichier"
                                label="Preuve d'exécution" multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="memoireContrat" placeholder="Charger le fichier"
                                label="Mémoire présentant les dispositions du contrat" multiple
                                prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="autresPieces" placeholder="Charger les fichiers"
                                label="Autre(s) pièce(s)" multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="red darken-1" text @click="closeDialog">
                        ANNULER
                    </v-btn>
                    <v-btn small color="green darken-1" text @click="addDemande">
                        ENVOYER LA SOLLICITATION
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Data table for displaying exclusions -->
        <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune sollicitation trouvée"
            :items="this.$store.getters['Auth/getSollicitation']" @click:row="goto" class="elevation-1 mb-5 px-5">
            <!-- Slot for custom row rendering -->
            <template v-slot:[`item.dateDemande`]="{ item }">
                {{ item.dateDemande | moment("DD MMMM YYYY") }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    components: { DatePicker },
    data: () => ({
        search: "",
        dialog: false,
        formTitle: "ENVOYER LA SOLLICITATION",
        nom: '',
        prenom: '',
        email: '',
        societe: '',
        pieceJointeDemande: null,
        copieContrat: null,
        preuveExecution: null,
        memoireContrat: null,
        autresPieces: null,
        headers: [
            { text: "Prenom", align: "start", sortable: false, value: "prenom" },
            { text: "Nom", sortable: false, value: "nom" },
            { text: "Email", sortable: false, value: "email" },
            { text: "Société", sortable: false, value: "societe" },
            { text: "Date de demande", sortable: false, value: "dateDemande" },
        ],
    }),
    created() {
        this.$store.dispatch("Auth/loadAllSollicitationByUser");
        this.$store.dispatch("Auth/getData");
    },
    methods: {
        ...mapActions({
            loadAllSollicitationByUser: "Auth/loadAllSollicitationByUser",
            sendSollicitation: "Auth/addSollicitation"
        }),
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
        goto(value) {
            const { id } = value;
            this.$router.push({ name: "show_mes_sollicitations", params: { id: id } });
        },
        addDemande() {
            const data = new FormData();
            data.append("prenom", this.prenom);
            data.append("nom", this.nom);
            data.append("email", this.email);
            data.append("societe", this.societe);
            data.append("pieceJointeDemande", this.pieceJointeDemande[0]);
            data.append("copieContrat", this.copieContrat[0]);
            data.append("preuveExecution", this.preuveExecution[0]);
            data.append("memoireContrat", this.memoireContrat[0]);
            data.append("autresPieces", this.autresPieces[0]);

            this.sendSollicitation(data);

            // Réinitialiser les champs du formulaire après l'envoi
            this.nom = '';
            this.prenom = '';
            this.email = '';
            this.societe = '';
            this.pieceJointeDemande = null;
            this.copieContrat = null;
            this.preuveExecution = null;
            this.memoireContrat = null;
            this.autresPieces = null;

            this.dialog = false;
        },
    }
};
</script>

<style></style>
